// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"218":"component---src-pages-404-tsx","591":"component---src-templates-home-tsx"}[chunkId] || chunkId) + "-" + {"218":"2b255e03971351bbaabe","591":"042c7a240d578d6b5acc","954":"f81e28d656d39de85371"}[chunkId] + ".js";
};